var map = {
	"./balraj.webp": 87707,
	"./geetha.webp": 97925,
	"./karthikeyan.webp": 49914,
	"./kowshalya.webp": 91694,
	"./krishnamoorthy.webp": 79953,
	"./krishnaveni.webp": 27951,
	"./manikandan.webp": 86041,
	"./manjularani.webp": 68483,
	"./nirmaladevi.webp": 31103,
	"./palanisamy.webp": 92448,
	"./prabhakaran.webp": 41902,
	"./revathi.webp": 50414,
	"./sathishkumar.webp": 32363,
	"./srinivasan.webp": 3473,
	"./tamilsai.webp": 47233,
	"./yoghananthan.webp": 64447
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94627;